import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [LIST_ORDER_FILES, LIST_ORDER_FILES_SUCCESS, LIST_ORDER_FILES_FAILURE] =
  createRequestActionTypes('chance/LIST_ORDER_FILES');
export const listOrderFiles = createAction(
  LIST_ORDER_FILES,
  (fileTyp, fileAttrVal1, fileAttrVal3) => ({
    fileTyp,
    fileAttrVal1,
    fileAttrVal3,
  }),
);
const listOrderFilesSaga = createRequestSaga(
  LIST_ORDER_FILES,
  chanceApi.getOrderFiles,
);

export function* orderFilesSaga() {
  yield takeLatest(LIST_ORDER_FILES, listOrderFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const orderFiles = handleActions(
  {
    [LIST_ORDER_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,
        fileAttrVal1: file.fileAttrVal1, //prjUuid
        fileAttrVal2: file.fileAttrVal2,
        fileAttrVal3: file.fileAttrVal3, //roUuid
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        crtNm: file.crtNm,
        crtDt: file.crtDt,
        cngNm: file.cngNm,
        cngDt: file.cngDt,
      })),
      error: null,
    }),
    [LIST_ORDER_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
  },
  initialState,
);

export default orderFiles;
